import nosleep from "nosleep.js";

export const NoSleep = new nosleep();
